import { api, LightningElement } from "lwc";
import classnames from "classnames";

import { assignedSlotNames } from "common/slot";

export default class extends LightningElement {
  @api variant: "main" | "right-sidebar" | "left-sidebar" = "main";

  private slots: string = "";

  private get className() {
    return classnames("layout", {
      "layout--header": this.showHeader,
      "layout--footer": this.showFooter,
      "layout--right-sidebar": this.variant === "right-sidebar",
      "layout--left-sidebar": this.variant === "left-sidebar",
      "layout--main": this.variant === "main",
    });
  }

  private get gridTemplateAreas() {
    const areas = [];

    if (this.showHeader) {
      areas.push("header");
    }

    areas.push("body");

    if (this.showFooter) {
      areas.push("footer");
    }

    return areas.map((a) => `"${a}"`).join(" ");
  }

  private get gridTemplateAreasBodyStacked() {
    const areas = ["main"];

    if (/sidebar$/.test(this.variant)) {
      areas.push("sidebar");
    }

    return areas.map((a) => `"${a}"`).join(" ");
  }

  private get computedStyles() {
    return `--grid-template-areas: ${this.gridTemplateAreas}; --grid-template-areas-body-stacked: ${this.gridTemplateAreasBodyStacked}`;
  }

  private handleSlotChange() {
    this.slots = assignedSlotNames(this.template).join(" ");
  }

  private get showHeader() {
    return this.slots.includes("header");
  }

  private get showFooter() {
    return this.slots.includes("footer");
  }

  private get showSidebar() {
    return this.variant !== "main";
  }

  private get sidebarClassName() {
    return this.variant;
  }
}
